module.exports = __webpack_public_path__ + "static/media/apartment.e954d3c8.png";